import React from "react";

function ExpanderCell({ row }) {
    return <span {...row.getToggleRowExpandedProps()}>
        {row.isExpanded ? <i className="fas fa-chevron-down"></i> : <i className="fas fa-chevron-right"></i>}
    </span>;
}

export default ExpanderCell;